import { defineMessages } from 'react-intl';
import { useCssHandles } from '../../../utils/functions';
import { useSelectTab } from '../TabLayout/hooks/useSelectTab';

const CSS_HANDLES = ['listItemChildren', 'listItemChildrenActive'] as const;

const TabListItemChildren: any = (props: any) => {
	const { tabId, defaultActiveTab, children, blockClass } = props;
	const { handles }: any = useCssHandles('vtex-tab-layout-0-x', CSS_HANDLES, blockClass);
	const { selectedTab, setSelectedTab } = useSelectTab();

	const isActive = (): boolean => {
		if (selectedTab) {
			if (selectedTab == tabId) {
				return true;
			}
			return false;
		} else if (defaultActiveTab) {
			return true;
		}
		return false;
	};

	const handleClick = () => setSelectedTab(tabId);
	return (
		<div
			data-selection={props.componentId}
			role="button"
			onClick={handleClick}
			className={`${handles.listItemChildren} ${isActive() ? handles.listItemChildrenActive : ''} ph2 pv2 ma2`}
		>
			{children}
		</div>
	);
};

const messages = defineMessages({
	title: {
		defaultMessage: '',
		id: 'admin/editor.tabListItem.title',
	},
	description: {
		defaultMessage: '',
		id: 'admin/editor.tabListItem.description',
	},
});

TabListItemChildren.schema = {
	title: messages.title.id,
	description: messages.description.id,
};

export default TabListItemChildren;
